module.exports = __webpack_public_path__ + "static/media/neill-kumar.8e220f68.jpg";